import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type IAgendaList = {
  agenda: {
    isBreak: boolean;
    item: string
  }[]
}

export const AgendaList = ({
  agenda
}: IAgendaList) => {

  const { t } = useTranslation();

  const thereAreAgendaItems = () => agenda && agenda.length > 0;

  const handleAgenda = () => {
    if(!thereAreAgendaItems()) {
      return (
        <Typography
          data-testid="agenda-list-empty"
          fontWeight={ 400 }
          fontSize={ "0.85rem" }
          marginTop={ "0.5rem" }
        >
          { t("Nessun programma in agenda") }
        </Typography>
      );
    }
    return <Stack
      id="agenda-list-items"
      data-testid="agenda-list-items"
      component={ "ul" }
      aria-label={ t("program_agenda", "Programma") }
      style={ {
        margin: "0 0 0.5rem",
        paddingLeft: "1.5rem"
      } }
    >
      { agenda?.map((agendaItem, indx) => (
        <li
          key={ indx }
          data-testid="agenda-list-item"
        >
          <Typography
            fontWeight={ 400 }
            fontSize={ "0.85rem" }
            lineHeight={ "1rem" }
          >
            { agendaItem.item }
          </Typography>
        </li>
      )) }
    </Stack>;
  };

  return (
    <>
      <Typography
        data-testid="agenda-list-title"
        fontWeight={ 700 }
        fontSize={ "0.875rem" }
        lineHeight={ "1rem" }
      >
        { t("program_agenda", "Programma") }:
      </Typography>
      { handleAgenda() }
    </>
  );
};
